import { backendAuthenticatedAxios } from '../index';

import { AxiosResponse } from 'axios';

interface GenerateStatementResponse {
  statement_id: string;
  file_url: string;
}

const generateRepaymentStatement = async (
  statementDate: string,
): Promise<AxiosResponse<GenerateStatementResponse>> => {
  const payload = {
    statement_date: statementDate,
  };

  return backendAuthenticatedAxios.post('/repayment/statement/generate', payload);
};

export default generateRepaymentStatement;
